import React, { useMemo } from 'react'
import { PageTitle } from '/src/app/root/components/common'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './storage-section.styles'
import { GridItemsWrapper } from './partials/grid-items-wrapper.js'
import { BackdropSection } from '../'
import { useSelector } from 'react-redux'

export const StorageSection = ({
    location,
    localFloorPlanDevices,
    setActiveBlur,
    activeBlurForStorage
}) => {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)
    const devices = useMemo(
        () =>
            localFloorPlanDevices?.filter(
                e => !e.hasOwnProperty('router_type')
            ),
        [localFloorPlanDevices]
    )
    const networkDevices = useMemo(
        () =>
            localFloorPlanDevices?.filter(e => e.hasOwnProperty('router_type')),
        [localFloorPlanDevices]
    )

    // const addToStorage = data => {
    //     setLocalFloorPlanDevices(() => {
    //         return localFloorPlanDevices.filter(item => data.id !== item.id)
    //     })
    //     setStorageFloorPlanDevices([...storageFloorPlanDevices, data])
    // }

    return (
        <Box className={classes.container}>
            <PageTitle className={classes.pageTitle} title={location?.name} />
            <Box className={classes.wrapper}>
                {activeBlurForStorage && (
                    <BackdropSection
                        customStyle={{
                            borderRadius: '20px',
                            width: '100%',
                            left: '0'
                        }}
                    />
                )}

                {networkDevices?.length > 0 && (
                    <Typography className={classes.heading}>
                        {`${locale.locations.storageSectionNetworkDevicesTitle}`}
                    </Typography>
                )}

                <GridItemsWrapper
                    floorPlanDevices={networkDevices}
                    setActiveBlur={setActiveBlur}
                    // addToStorage={addToStorage}
                />
                {devices?.length > 0 && (
                    <Typography className={classes.heading}>
                        {`${locale.locations.storageSectionDevicesTitle}`}
                    </Typography>
                )}

                <GridItemsWrapper
                    floorPlanDevices={devices}
                    setActiveBlur={setActiveBlur}
                    // addToStorage={addToStorage}
                />
            </Box>
        </Box>
    )
}
